module.exports = __webpack_public_path__ + "static/media/v13m.7d2a069f.mp4";